(function(){
    'use strict';
    angular.module('app').controller('ServiceTicketDetailsController', ServiceTicketDetailsController);
    
    ServiceTicketDetailsController.$inject = [
        'ClientService',
        'ServiceRequestTicketService',
        'ServiceTicketsLogsTable',
        'ServiceCommentTicketsTable',
        'toastr',
        '$routeParams',
        '$window'
    ];
    
    function ServiceTicketDetailsController(
        ClientService,
        ServiceRequestTicketService,
        ServiceTicketsLogsTable,
        ServiceCommentTicketsTable,
        toastr,
        $routeParams,
        $window
    ) {

        const vm = this;
        vm.ticketId = $routeParams.id;
        
        vm.data={};
        vm.assign=[
            'Assign to Me',
            'Unassign'
        ]

        vm.status=[
            {name:'OPEN', value:'OPEN'},
            {name:'IN PROGRESS', value:'IN_PROGRESS'},
            {name:'COMPLETED', value:'COMPLETED'},
            {name:'CANCELLED', value:'CANCELLED'},
        ]

        init();

        vm.back = ()=>{
            $window.history.back();
        }

        vm.updateStatus = ()=>{
            const status = vm.data.status.value
            ServiceRequestTicketService.updateTicketStatus(vm.ticketId,
                res=>{
                    toastr.success('Successfully Update')
                },
                err=>{
                    toastr.error(err.code)
                },{status:status}
            )
        }

        vm.assignUser = ()=>{
            ServiceRequestTicketService.assignUser(vm.ticketId,
                res=>{
                    toastr.success('Successfully Update')
                },
                err=>{
                    toastr.error(err.code)
            })
        }

        function init(){
            vm.commentLogTable = new ServiceTicketsLogsTable(vm.ticketId).tableData;
            vm.commentTableData = new ServiceCommentTicketsTable(vm.ticketId).tableData;
            fetchServiceTicketDetail();
        }

        function fetchServiceTicketDetail(){
            ServiceRequestTicketService.ticketDetails(vm.ticketId,
                res=>{
                    vm.data=res
                    vm.data.assigneeId = vm.data.assigneeId ? 'Assign to me' : 'Unassign'
                },
                err=>{
                    console.log(err)
                }
            )
        }

    }
})();



// WEBPACK FOOTER //
// ./js/controllers/service-tickets/ServiceTicketDetailsController.js